import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

const headers = new Headers();
headers.append('Content-Type', 'application/json');

export default function updateLogEvent(flag,key) {
	return fetch(
		`${ENDPOINT_URL}/addtolog`,
		{
			method: 'POST',
			credentials: 'include',
		headers,
			body: JSON.stringify({
				flag,
				key,
				
			}),
		})
	
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
